import React, { Component } from "react"
import { Modal } from "antd"
import MasterForm from "../multisteps/formMultistep"

class QuestionModal extends Component {
	render() {
		return (
			<Modal
				title='Question Modal'
				visible={this.props.isOpen}
				onOk={this.props.onCloseModal}
				onCancel={this.props.onCloseModal}
			>
				<MasterForm />
			</Modal>
		)
	}
}

export default QuestionModal
